import { useState as State , useLayoutEffect as LFX , useRef as Ref } from "react";
import Routers from "./Routers/Routers";

const Splash = () => {

    const Canvas = Ref(null);
    const [ Splashing , Exit ] = State(true);

    LFX(
        () => {

            setTimeout(
                () => {
                    Exit(false);
                }, 5000
            );

            const C = Canvas.current;
            if (!C) return;
            C.width = C.offsetWidth;
            C.height = C.offsetHeight;
            const Context = C.getContext("2d");
            let Particles = [];
            let Count = 250;
            
            function Particle() {
                this.x = Math.random() * C.width;
                this.y = C.height + Math.random() * 200;
                this.speed = 0.5 + Math.random();
                this.radius = Math.random() * 3;
                this.opacity = Math.random() * 0.6;
            }

            for (let i = 0; i < Count; i++) {
                Particles.push(new Particle());
            }

            function Draw() {
                Context.clearRect(0, 0, C.width, C.height);
                Particles.forEach(
                    (p, i) => {
                        Context.beginPath();
                        Context.fillStyle = `rgba(255,255,255,${p.opacity})`;
                        Context.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
                        Context.fill();
                        p.y -= p.speed;
                        if (p.y <= -10) Particles[i] = new Particle();
                    }
                );
            };

            function Loop() {
                requestAnimationFrame(Loop);
                Draw();
            }; Loop();

        }, []
    );

    return(
        <screen-switcher>
            {
                Splashing
                ? <splash-screen>
                    <canvas id="Canvas" ref={Canvas} className="Canvas" ></canvas>
                    <div className="Splash-Content">
                        <dotlottie-wc src="/Lottie/Splash.lottie" style={ { "width" : "100px" , "height" : "100px" } } autoplay loop ></dotlottie-wc>
                        <h1 className="Splash-Title" >The Friend Zone Cafe</h1>
                        <h3 className="Splash-Subtitle" >EAT  |  ENJOY  |  REPEAT</h3>
                    </div>
                </splash-screen>
                : <Routers />
            }
        </screen-switcher>
    );

};

export default Splash;